module.exports = __webpack_public_path__ + "248f9c2f9b6e35c207b8ce8258f99faa.svg";